import { useEffect, useState } from "react";
import axios from "axios";
import Footer from "../../../../../components/Footer/Footer";
import InnerNav from "../../../../../components/InnerNav/InnerNav";
import { useFormData } from '../../ContextData/ContextData';
import "./Aspect.scss";

const Aspect = () => {
  const { userData } = useFormData();
  
  const [planetaryAspects, setPlanetaryAspects] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAspects = async () => {
      try {
        const res = await axios.get(
          "https://core-c343.onrender.com/api/planetary-aspects",
          {
            params: {
              year: userData.year,
              month: userData.month,
              day: userData.day,
              hour: userData.hour,
              minute: userData.minute
            },
          }
        );

        const positions = res.data.positions || {};
        const aspects = res.data.aspects || {};

        const merged = {};
        Object.keys(positions).forEach((planet) => {
          merged[planet.toUpperCase()] = {
            degree: positions[planet],
            aspects: aspects[planet.toUpperCase()] || {},
          };
        });

        setPlanetaryAspects(merged);
      } catch (err) {
        console.error("Error fetching planetary aspects:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAspects();
  }, []);

  const planets = Object.keys(planetaryAspects);

  return (
    <div className="aspect-table">
      <InnerNav />
      <h2>Planetary Aspects (Western)</h2>

      {loading ? (
        <p>Loading aspects...</p>
      ) : (
        <div className="aspect-grid">
          <div className="header-row">
            <div className="cell header">Planet</div>
            <div className="cell header">Degree</div>
            {planets.map((p) => (
              <div className="cell header" key={p}>
                {p}
              </div>
            ))}
          </div>

          {planets.map((planet) => (
            <div className="row" key={planet}>
              <div className="cell label">{planet}</div>
              <div className="cell">{planetaryAspects[planet].degree ?? "--"}</div>
              {planets.map((target) => {
                const val = planetaryAspects[planet]?.aspects?.[target];
                if (!val || val === "--") return <div className="cell" key={target}>--</div>;

                // Split "TYPE ORB" into two lines
                const [type, orb] = val.split(" ");
                return (
                  <div className="cell" key={target}>
                    <div className="aspect-type">{type}</div>
                    <div className="aspect-orb">{orb}</div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Aspect;
